import React, { Component, useRef, Fragment } from 'react';

import { translate } from 'react-i18next';
import {
    FormGroup,
    FormControl,
    ControlLabel,
    Panel,
    Col,
    Row
} from 'react-bootstrap';
import SpinnerButton from '../components/SpinnerButton';
import DismissableAlert from '../components/DismissableAlert';
import BackupCodeDisplay from '../components/BackupCodeDisplay';
import SecurityQuestionsForm from '../components/SecurityQuestionsForm';

import './Login.css';
import config from '../config';
import { Link } from 'react-router-dom';

import logo from '../logo.png';
import cyberlogo from '../cyber.jpg';
import axios from 'axios';
import ReCAPTCHA from "react-google-recaptcha";

const recaptchaRef = React.createRef();

axios.defaults.withCredentials = true;

class Login extends Component {
    
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            sentEmail: false,
            email: '',
            saved: false,
            captcha: '',
            token: '',
            secret: '',
            backupCodes: [],
            remember: false,
            password: '',
            twoFactorRequired: false,
            twoFactorSetupRequired: false,
            hasConfirmedBackupCodes: false,
            hasEnteredToken: false,
            hasCompletedQuestions: false,
            authToken: '',
            useBackupCode: false,
            backupCode: '',
            userUUID: '',
            qrCode: '',
            error: {
                hidden: true,
                title: '',
                message: '',
                style: 'danger'
            }
        };
    }

    componentDidMount() {
    }

    validateForm() {
        return this.state.email.length > 0 && this.state.password.length > 0;
    }

    handleChange = event => {
        const { id, value } = event.target;
        this.setState({ [id]: value,
            error: { hidden: true, title: '', message: '', style: 'danger' }
         });
    };

    onCaptchaChange = value => {
        this.setState({
            captcha: value
        });
    };

    handleBackupCodeConfirmChange = (confirmed) => {
        this.setState({ hasConfirmedBackupCodes: confirmed });
    };


    handleSecurityQuestionSubmit = () => {
        const answers = this.securityForm.getAnswers();
    
        if (answers.length < 3) {
            this.setState({
                error: {
                    hidden: false,
                    title: 'Error:',
                    message: 'Please select and answer 3 unique questions.',
                    style: 'danger'
                }
            });
            return;
        }
    
        this.setState({ isLoading: true });
    
        axios.post(`${config.baseURL}/auth/securityQuestions`, {
            userId: this.state.userUUID,
            answers
        }, {
            timeout: 10000
        }).then(() => {
            this.setState({
                hasCompletedQuestions: true,
                saved: true,
                isLoading: false,
                error: { hidden: true, title: '', message: '', style: 'danger' }
            });
        }).catch((error) => {
            const errorMessage = error.code === 'ECONNABORTED' || error.message.includes('timeout')
                ? 'Request timed out. Please try again.'
                : 'Failed to save your security questions.';

            this.setState({
                isLoading: false,
                error: {
                    hidden: false,
                    title: 'Error:',
                    message: errorMessage,
                    style: 'danger'
                }
            });
        });
    };

    sendEmailToken = () => {

        const { t } = this.props;

        axios
        .post(`${config.baseURL}/auth/two_factor_token`, {}, {
            timeout: 10000
        })
        .then((response) => {
            this.setState({ sentEmail: true,  error: {
                hidden: false,
                title: `${t('Login.two_fa_required')}:`,
                message: `${t('Login.provide_two_fa_code')}`,
                style: 'warning'
            } });
        })
        .catch((error) => {
            console.log(error);
            const errorMessage = error.code === 'ECONNABORTED' || error.message.includes('timeout')
                ? 'Request timed out. Please try again.'
                : 'Failed to send email token. Please try again.';

            this.setState({
                error: {
                    hidden: false,
                    title: `${t('Login.error')}:`,
                    message: errorMessage,
                    style: 'danger'
                }
            });
        });
    }

    generateSecret() {
        var self = this;

        axios
            .post(`${config.baseURL}/auth/generateSecretLogin`, {}, {
                timeout: 10000
            })
            .then(function(response) {
                self.setState({ qrCode: response.data.qrCode, secret: response.data.secret });
            })
            .catch(function(error) {
                console.log(error);
                const errorMessage = error.code === 'ECONNABORTED' || error.message.includes('timeout')
                    ? 'Request timed out. Please refresh and try again.'
                    : 'Failed to generate QR code. Please try again.';

                self.setState({
                    isLoading: false,
                    error: {
                        hidden: false,
                        title: 'Error:',
                        message: errorMessage,
                        style: 'danger'
                    }
                });
            });
    }

    renderFormContent() {

        const { t } = this.props;

        const { twoFactorRequired, twoFactorSetupRequired, saved} = this.state;
        if (twoFactorRequired) {
            
            return (
                <Fragment>
                    <FormGroup controlId={this.state.useBackupCode ? "backupCode" : "authToken"} bsSize="sm">
                        <ControlLabel>
                            {this.state.useBackupCode ? t('Login.backup_code') : t('Login.auth_code')}
                        </ControlLabel>
                        <FormControl
                            autoFocus
                            type="text"
                            value={this.state.useBackupCode ? this.state.backupCode : this.state.authToken}
                            onChange={this.handleChange}
                        />
                         <small>
                            {this.state.useBackupCode ? (
                                <>
                                <a href="#" onClick={(e) => { e.preventDefault(); this.setState({ useBackupCode: false }); }}>
                                    {t('Login.use_auth_app')}
                                </a>
                                </>
                            ) : (
                                <>
                                <div style={{ marginTop: '0.75rem' }}>
                                    <div>
                                        <small className="text-muted">
                                            {t('Login.dont_have_device')}{' '}
                                            <br/>
                                            <a href="#" onClick={(e) => { e.preventDefault(); this.sendEmailToken(); }}>
                                                {t('Login.request_via_email')}
                                            </a>
                                        </small>
                                    </div>

                                    <div>
                                        <small className="text-muted">
                                            <a href="#" onClick={(e) => { e.preventDefault(); this.setState({ useBackupCode: true }); }}>
                                                {t('Login.use_backup_code')}
                                            </a>
                                        </small>
                                    </div>

                                    <div>
                                        <small className="text-muted">
                                            <Link to="/reset-2fa">
                                                {t('Login.lost_2fa')}
                                            </Link>
                                        </small>
                                    </div>
                                </div>
                                </>
                            )}
                            </small>
                    </FormGroup>
                    
                    <SpinnerButton
                        block
                        bsStyle="primary"
                        bsSize="large"
                        disabled={!this.validateForm()}
                        type="submit"
                        isLoading={this.state.isLoading}
                        text={`${t('Login.login')}`}
                        loadingText={`${t('Login.logging_in')}`}
                    />
                </Fragment>
                
            );

        } else if (saved) {

            return (
                <Fragment>
            
                    <BackupCodeDisplay
                        backupCodes={this.state.backupCodes}
                        confirmed={this.state.hasConfirmedBackupCodes}
                        onConfirmChange={this.handleBackupCodeConfirmChange}
                    />
                    <SpinnerButton
                        block
                        bsStyle="primary"
                        bsSize="large"
                        type="submit"
                        isLoading={this.state.isLoading}
                        text={`${t('Login.re_authenticate')}`}
                        loadingText={`${t('Login.navigating')}`}
                        disabled={!this.state.hasConfirmedBackupCodes}
                    />
                </Fragment>
                
            );

        }else if (twoFactorSetupRequired && !saved) {
            if (!this.state.hasEnteredToken) {
                // QR + token entry
                return (
                    <Fragment>
                        <img
                            src={this.state.qrCode}
                            alt="QR"
                            className="center-block img-responsive"
                            style={{ width: 212, height: 212 }}
                        />
                        <FormGroup controlId="token" bsSize="sm">
                            <ControlLabel>{t('Login.auth_code')}</ControlLabel>
                            <FormControl
                                autoFocus
                                type="text"
                                value={this.state.token}
                                onChange={this.handleChange}
                            />
                        </FormGroup>
                        <SpinnerButton
                            block
                            bsStyle="primary"
                            bsSize="large"
                            type="button"
                            isLoading={this.state.isLoading}
                            onClick={() => {
                                this.setState({ isLoading: true });
                                axios.post(`${config.baseURL}/auth/verifySecretSetupLogin`, {
                                    token: this.state.token
                                }, {
                                    timeout: 10000
                                }).then((response) => {
                                    this.setState({
                                        backupCodes: response.data.backupCodes,
                                        hasEnteredToken: true,
                                        isLoading: false,
                                        error: { hidden: true, title: '', message: '', style: 'danger' }
                                    });
                                }).catch((err) => {
                                    let errorMessage = 'Invalid token';

                                    if (err.code === 'ECONNABORTED' || err.message.includes('timeout')) {
                                        errorMessage = 'Request timed out. Please try again.';
                                    } else if (!err.response) {
                                        errorMessage = 'Unable to connect to the server. Please check your internet connection.';
                                    } else if (err.response && err.response.data && err.response.data.message) {
                                        errorMessage = err.response.data.message;
                                    }

                                    this.setState({
                                        isLoading: false,
                                        error: {
                                            hidden: false,
                                            title: `${t('Login.error')}:`,
                                            style: 'danger',
                                            message: errorMessage
                                        }
                                    });
                                });
                            }}
                            text={t('Login.verify_secret')}
                            loadingText={t('Login.verifying_secret')}
                        />
                    </Fragment>
                );
            } else if (!this.state.hasCompletedQuestions) {
                return (
                    <Fragment>
                        <SecurityQuestionsForm ref={(ref) => (this.securityForm = ref)} />
                        <SpinnerButton
                            block
                            bsStyle="success"
                            bsSize="large"
                            type="button"
                            isLoading={this.state.isLoading}
                            onClick={this.handleSecurityQuestionSubmit}
                            text="Save and Continue"
                            loadingText="Saving..."
                        />
                    </Fragment>
                );
            }
        } else {
            return (
                <Fragment>
                    <FormGroup controlId="email" bsSize="sm">
                        <ControlLabel>
                            {t('Login.email')}
                        </ControlLabel>
                        <FormControl
                            autoFocus
                            type="text"
                            value={this.state.email}
                            onChange={this.handleChange}
                        />
                    </FormGroup>
                    <FormGroup controlId="password" bsSize="sm">
                        <ControlLabel>
                            {t('Login.password')}
                        </ControlLabel>
                        <FormControl
                            value={this.state.password}
                            onChange={this.handleChange}
                            type="password"
                        />
                        <small>
                            {t('Login.forgot_password')}{' '}
                            <Link to="/login/forgotten">
                                {t('Login.reset_here')}
                            </Link>
                        </small>
                    </FormGroup>
                    <FormGroup>
                        <ReCAPTCHA
                            sitekey={config.recaptchaSiteKey}
                            onChange={this.onCaptchaChange}
                            ref={recaptchaRef}
                        />
                    </FormGroup>
                    <SpinnerButton
                        block
                        bsStyle="primary"
                        bsSize="large"
                        disabled={!this.validateForm()}
                        type="submit"
                        isLoading={this.state.isLoading}
                        text={`${t('Login.login')}`}
                        loadingText={`${t('Login.logging_in')}`}
                    />
                </Fragment>
            );
        }
    }
    

    handleSubmit = event => {
        const { t } = this.props;

        event.preventDefault();

        this.setState({ isLoading: true });

        var self = this;

        try {
            if (self.state.saved) {

                this.setState({
                    isLoading: false,
                    email: '',
                    captcha: '',
                    sentEmail: false,
                    token: '',
                    saved: false,
                    secret: '',
                    remember: false,
                    password: '',
                    twoFactorRequired: false,
                    twoFactorSetupRequired: false,
                    hasConfirmedBackupCodes: false,
                    authToken: '',
                    useBackupCode: false,
                    backupCode: '',
                    userUUID: '',
                    qrCode: '',
                    error: {
                        hidden: true,
                        title: '',
                        message: '',
                        style: 'danger'
                    }
                });

            } else if (!self.state.twoFactorRequired && !self.state.twoFactorSetupRequired) {

            axios
                .post(`${config.baseURL}/auth/login`, {
                    email: this.state.email,
                    password: this.state.password,
                    remember: this.state.remember,
                    captcha: this.state.captcha
                }, {
                    timeout: 10000 // 10 second timeout
                })
                .then(function(response) {
                    const user = response.data.user;
                    user.isAuthenticated = true;

                    let roles = new Set();
                    for (var key in user.organisationRoles) {
                        const organisationRoles = user.organisationRoles[key];
                        for (const role of organisationRoles) {
                            roles.add(role);
                        }
                    }

                    if (roles.has("staff_engineer")) {
                        user.isEngineer = true;
                    } else {
                        user.isEngineer = false;
                    }


                    self.props.userHasAuthenticated(true, user);
                })
                .catch(function(error) {

                    if(recaptchaRef && recaptchaRef.current) {
                        recaptchaRef.current.reset();
                    }

                    console.log(`Error: ${JSON.stringify(error)}`);

                    // Handle timeout errors
                    if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
                        self.setState({
                            isLoading: false,
                            error: {
                                hidden: false,
                                title: `${t('Login.error')}:`,
                                message: 'Login request timed out. Please check your connection and try again.',
                                style: 'danger'
                            }
                        });
                        return;
                    }

                    // Handle network errors
                    if (!error.response) {
                        self.setState({
                            isLoading: false,
                            error: {
                                hidden: false,
                                title: `${t('Login.error')}:`,
                                message: 'Unable to connect to the server. Please check your internet connection and try again.',
                                style: 'danger'
                            }
                        });
                        return;
                    }

                    if (error && error.response && error.response.data && error.response.data.message == 'ReCAPTCHA error') {

                        self.setState({
                            isLoading: false,
                            error: {
                                hidden: false,
                                title: `${t('Login.error')}:`,
                                message: 'ReCAPTCHA verification failed. Please complete the ReCAPTCHA challenge and try again.',
                                style: 'danger'
                            }
                        });
                    } else if (error && error.response && error.response.data && error.response.data.twoFactorRequired) {
                        console.log(`User UUID needs 2FA: ${error.response.data.userUUID}`);
                        self.setState({
                            isLoading: false,
                            twoFactorRequired: true,
                            userUUID: error.response.data.userUUID,
                            error: {
                                hidden: false,
                                title: `${t('Login.two_fa_required')}:`,
                                message: `${t('Login.provide_two_fa_code')}`,
                                style: 'warning'
                            }
                        });
                    } else if (error && error.response && error.response.data && error.response.data.awaiting2FASetup) {

                        console.log(`User UUID needs 2FA setup: ${error.response.data.userUUID}`);
                        self.generateSecret();
                        self.setState({
                            isLoading: false,
                            twoFactorSetupRequired: true,
                            userUUID: error.response.data.userUUID,
                            error: {
                                hidden: false,
                                title: `${t('Login.two_fa_required')}:`,
                                message: `${t('Login.setup_two_fa')}`,
                                style: 'warning'
                            }
                        });
                    } else {
                        self.setState({
                            isLoading: false,
                            error: {
                                hidden: false,
                                title: `${t('Login.error')}:`,
                                message: `${t('Login.incorrect_credentials')}`,
                                style: 'danger'
                            }
                        });
                    }
                    
                });

            } else if (self.state.twoFactorSetupRequired) {

            axios
                .post(`${config.baseURL}/auth/verifySecretSetupLogin`, {
                    token: self.state.token
                }, {
                    timeout: 10000
                })
                .then(function(response) {

                    self.setState({
                        // saved: true,
                        isLoading: false,
                        backupCodes: response.data.backupCodes,
                        hasEnteredToken: true,
                        error: {
                            hidden: false,
                            title: `${t('Login.success')}:`,
                            style: 'success',
                            message: `${t(
                                'Login.saved_message_recovery_questions'
                            )}`
                        }
                    });

                })
                .catch(function(err) {
                    // Handle timeout errors
                    if (err.code === 'ECONNABORTED' || err.message.includes('timeout')) {
                        self.setState({
                            isLoading: false,
                            error: {
                                hidden: false,
                                title: `${t('Login.error')}:`,
                                style: 'danger',
                                message: 'Request timed out. Please try again.'
                            }
                        });
                        return;
                    }

                    // Handle network errors
                    if (!err.response) {
                        self.setState({
                            isLoading: false,
                            error: {
                                hidden: false,
                                title: `${t('Login.error')}:`,
                                style: 'danger',
                                message: 'Unable to connect to the server. Please check your internet connection.'
                            }
                        });
                        return;
                    }

                    self.setState({
                        isLoading: false,
                        error: {
                            hidden: false,
                            title: `${t('Login.error')}:`,
                            style: 'danger',
                            message: err.response.data.message || 'Verification failed. Please try again.'
                        }
                    });
                });

            } else {
                // 2FA Verification
                const endpoint = this.state.useBackupCode
                ? `${config.baseURL}/auth/verify2FABackup`
                : `${config.baseURL}/auth/verify`;

                const payload = {
                userUUID: this.state.userUUID,
                };

                if (this.state.useBackupCode) {
                payload.backupCode = this.state.backupCode;
                } else {
                payload.authToken = this.state.authToken;
                }

                axios.post(endpoint, payload, {
                    timeout: 10000 // 10 second timeout
                })
                .then(function(response) {

                    const user = response.data.user;
                    user.isAuthenticated = true;

                    let roles = new Set();
                    for (var key in user.organisationRoles) {
                        const organisationRoles = user.organisationRoles[key];
                        for (const role of organisationRoles) {
                            roles.add(role);
                        }
                    }

                    if (roles.has("staff_engineer")) {
                        user.isEngineer = true;
                    } else {
                        user.isEngineer = false;
                    }


                    self.props.userHasAuthenticated(true, user);
                })
                .catch(function(error) {

                    // Handle timeout errors
                    if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
                        self.setState({
                            isLoading: false,
                            error: {
                                hidden: false,
                                title: `${t('Login.error')}:`,
                                message: 'Verification request timed out. Please try again.',
                                style: 'danger'
                            }
                        });
                        return;
                    }

                    // Handle network errors
                    if (!error.response) {
                        self.setState({
                            isLoading: false,
                            error: {
                                hidden: false,
                                title: `${t('Login.error')}:`,
                                message: 'Unable to connect to the server. Please check your internet connection.',
                                style: 'danger'
                            }
                        });
                        return;
                    }

                    // Handle specific error messages from server
                    const errorMessage = (error.response && error.response.data && error.response.data.message)
                        ? error.response.data.message
                        : `${t('Login.incorrect_token')}`;

                    self.setState({
                        isLoading: false,
                        error: {
                            hidden: false,
                            title: `${t('Login.error')}:`,
                            message: errorMessage,
                            style: 'danger'
                        }
                    });

                });
            }
        } catch (e) {
            this.setState({
                isLoading: false,
                error: {
                    hidden: false,
                    title: `${t('Login.error')}:`,
                    message: `${t('Login.unknown_error')}:`,
                    style: 'danger'
                }
            });
        }
    };

    render() {
        const { t } = this.props;

        document.title = `MySign Digital Screen Solutions | ${t(
            'Login.title'
        )}`;

        return (
            <div className="Login">
                <Row>
                    <Col
                        xs={10}
                        sm={6}
                        md={6}
                        lg={4}
                        xsOffset={1}
                        smOffset={3}
                        mdOffset={3}
                        lgOffset={4}
                    >
                        <Panel>
                            <Panel.Body>
                            
                                <form onSubmit={this.handleSubmit}>
                                <a href="https://mysign.uk.com">
                                <img
                                    src={logo}
                                    alt="logo"
                                    className="center-block img-responsive"
                                    style={{ width: 400, height: 123 }}
                                />
                                </a>

                                    <DismissableAlert
                                        title={this.state.error.title}
                                        message={this.state.error.message}
                                        hidden={this.state.error.hidden}
                                        style={this.state.error.style}
                                    />

                                    {this.renderFormContent()}

                                </form>
                            </Panel.Body>
                        </Panel>
                        <small style={{display: 'flex',  justifyContent:'center', alignItems:'center'}}>
                            <Link to="/terms" style={{ marginRight: '0.5rem' }} >
                                {t('Login.terms')}
                            </Link>
                            {' | '}
                            <Link to="/privacy" style={{ marginLeft: '0.5rem', marginRight: '0.5rem' }} >
                                {t('Login.privacy')}
                            </Link>
                            {' | '}
                            <a href="https://mysign.uk.com" style={{ marginLeft: '0.5rem' }} >
                                MySign Home Page
                            </a>
                        </small>
                        <img
                                    src={cyberlogo}
                                    alt="logo"
                                    className="center-block img-responsive"
                                    style={{ width: 400, height: 100 }}
                                />

                    </Col>
                </Row>
            </div>
        );
    }
}

export default translate('translations')(Login);
